import {
  CreditCardIcon,
  HomeIcon,
  LogOutIcon,
  LucideProps,
  MessageSquare,
  SettingsIcon,
  UserIcon,
  UsersIcon,
} from 'lucide-react';
import { ForwardRefExoticComponent, RefAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@auth/contexts/AuthContext';

export type NavItem = {
  label: string;
  href: string;
  icon: ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>;
};

export type MenuItem = {
  label: string;
  href?: string;
  onClick?: () => void;
  icon: ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>;
};

export type NavItems = {
  sidebar: NavItem[];
  org: MenuItem[];
  userNav: MenuItem[];
};

export function useNavItems(): NavItems {
  const { logout } = useAuth();
  const { t } = useTranslation();

  return {
    sidebar: [
      {
        label: t('navigation.home'),
        href: '/dashboard',
        icon: HomeIcon,
      },
      {
        label: t('navigation.crm'),
        href: '/crm',
        icon: UsersIcon,
      },
      {
        label: t('navigation.messaging'),
        href: '/messaging',
        icon: MessageSquare,
      },
      {
        label: t('navigation.settings'),
        href: '/settings',
        icon: SettingsIcon,
      },
    ],
    org: [
      {
        label: t('navigation.settings'),
        href: '/settings',
        icon: SettingsIcon,
      },
      {
        label: t('navigation.billing'),
        href: '/billing',
        icon: CreditCardIcon,
      },
    ],
    userNav: [
      {
        label: t('navigation.profile'),
        href: '/profile',
        icon: UserIcon,
      },
      {
        label: t('navigation.logout'),
        onClick: logout,
        icon: LogOutIcon,
      },
    ],
  };
}
